document.addEventListener('DOMContentLoaded', function () {
    const slidesContainer = document.querySelector('.bion-bion__slides');
    if (!slidesContainer) {
        return; // Если блок слайдов не найден, выполнение прекращается
    }

    const slides = document.querySelectorAll('.bion-bion__slide');
    const buttonsContainer = document.querySelector('.bion-bion__slides-buttons');
    if (!buttonsContainer) {
        console.warn('Контейнер с кнопками .bion-bion__slides-buttons не найден.');
        return; // Прекращаем выполнение, если контейнер кнопок отсутствует
    }

    const leftButton = buttonsContainer.querySelector('.button-larrow');
    const rightButton = buttonsContainer.querySelector('.button-rarrow');

    if (!leftButton || !rightButton) {
        console.warn('Кнопки .button-larrow или .button-rarrow не найдены внутри .bion-bion__slides-buttons.');
        return; // Прекращаем выполнение, если кнопки отсутствуют
    }

    let currentIndex = 0;
    const intervalTime = 10000; // Время между слайдами (10 секунд)
    const transitionDuration = 500; // Длительность анимации (в миллисекундах)
    let interval; // Переменная для интервала
    let isAnimating = false; // Флаг анимации для предотвращения конфликтов

    // Функция для показа конкретного слайда
    function showSlide(index) {
        isAnimating = true; // Устанавливаем флаг анимации
        slides.forEach((slide, i) => {
            if (i === index) {
                slide.style.display = 'grid';
                setTimeout(() => {
                    slide.classList.add('fade-in');
                    slide.classList.remove('fade-out');
                }, 50); // Небольшая задержка для корректного срабатывания `opacity`
            } else {
                slide.classList.remove('fade-in');
                slide.classList.add('fade-out');
                setTimeout(() => {
                    slide.style.display = 'none'; // Скрываем слайд после завершения анимации
                }, transitionDuration);
            }
        });
        setTimeout(() => {
            isAnimating = false; // Снимаем флаг анимации после завершения
        }, transitionDuration + 50);
    }

    // Функция для перехода к следующему слайду
    function nextSlide() {
        if (isAnimating) return; // Если анимация в процессе, прерываем
        currentIndex = (currentIndex + 1) % slides.length; // Возврат к первому слайду, если достигнут конец
        showSlide(currentIndex);
    }

    // Функция для перехода к предыдущему слайду
    function prevSlide() {
        if (isAnimating) return; // Если анимация в процессе, прерываем
        currentIndex = (currentIndex - 1 + slides.length) % slides.length; // Возврат к последнему слайду, если достигнуто начало
        showSlide(currentIndex);
    }

    // Функция для сброса автоматического переключения (при взаимодействии с кнопками)
    function resetInterval() {
        clearInterval(interval); // Сброс текущего интервала
        interval = setInterval(nextSlide, intervalTime); // Перезапуск интервала
    }

    // Обработчики событий для кнопок
    leftButton.addEventListener('click', () => {
        prevSlide();
        resetInterval();
    });

    rightButton.addEventListener('click', () => {
        nextSlide();
        resetInterval();
    });

    // Показываем первый слайд
    showSlide(currentIndex);

    // Устанавливаем автоматическое переключение слайдов
    interval = setInterval(nextSlide, intervalTime);
});
